import { useEffect, useRef } from "react";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events";
import { useMagicMomentStore } from "./use-magic-moment-store";
import { CollapsibleBanner } from "./collapsible-banner";
import { Sprout } from "lucide-react";

interface ReactivationBannerProps {
  teenName?: string | null;
  teenId?: string | null;
  conversationId?: string | null;
}

export function ReactivationBanner({
  teenName,
  teenId,
  conversationId,
}: ReactivationBannerProps) {
  const { track } = useTrackEvent();
  const viewTracked = useRef(false);
  const bannerExpanded = useMagicMomentStore((s) => s.bannerExpanded);
  const toggleBanner = useMagicMomentStore((s) => s.toggleBanner);

  useEffect(() => {
    if (!viewTracked.current) {
      viewTracked.current = true;
      track(PostHogEvents.REACTIVATION_BANNER_VIEW, {
        teen_id: teenId,
        conversation_id: conversationId,
      });
    }
  }, []);

  const handleToggle = () => {
    const newState = bannerExpanded ? "collapsed" : "expanded";
    track(PostHogEvents.REACTIVATION_BANNER_TOGGLE, {
      teen_id: teenId,
      state: newState,
    });
    toggleBanner();
  };

  return (
    <CollapsibleBanner
      title={`${teenName || "Your teen"} just reactivated!`}
      icon={<Sprout className="h-6 w-6 text-text-primary" />}
      expanded={bannerExpanded}
      onToggle={handleToggle}
    >
      <div className="flex flex-col gap-2">
        <p className="text-sm leading-5 text-text-secondary">
          Take some extra time to send a thoughtful message today.
        </p>
      </div>
    </CollapsibleBanner>
  );
}
